import { BodyResearchAmountVM } from 'front-office/view-models/research-amount';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyResearchAmountVM, keyof BodyResearchAmountVM>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'amount',
    label: 'Importo',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'dateFrom',
    label: 'Valido dal',
  },
  {
    id: 'dateTo',
    label: 'Valido al',
  },
  {
    id: 'actions',
    label: '',
  },
];
